import { Col, Select, Typography } from "antd";
import { cptCodeOptions } from "../../domain/notes.domain";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { setRecordingDetail } from "../../slices/recordingsSlice";
import { LC_KEYS } from "../../utils/constants";
import styles from "./createnotemodal.module.scss";

const CPTCodeSelector = () => {
  const componentName = "createnotemodal";
  const dispatch = useAppDispatch();

  const { recordingDetail } = useAppSelector((state) => state.recordings);

  return (
    <Col span={12} className={`${styles[`${componentName}__modal-row`]}`}>
      <Typography.Text>CPT Code: (optional)</Typography.Text>

      <Select
        value={recordingDetail.duration_type}
        placeholder="Select CPT Code"
        onChange={(value) => {
          localStorage.setItem(LC_KEYS.CPT_CODE, value?.toString());
          dispatch(
            setRecordingDetail({
              ...recordingDetail,
              duration_type: value,
            }),
          );
        }}
        optionFilterProp="label"
        showSearch
        options={cptCodeOptions}
        optionRender={(option) => {
          const hasDesc = "desc" in option.data && option.data.desc;
          return (
            <span>
              {option.data.label}
              {hasDesc ? ` - ${(option.data as any).desc}` : ""}
            </span>
          );
        }}
      />
    </Col>
  );
};

export default CPTCodeSelector;
